import React, { Component } from "react";
import Experience from "../experience/Experience";
import Education from "../education/EducationComponent";
import Projects from "../projects/Projects";
import Opensource from "../opensource/Opensource";
import { Fade } from "react-reveal";

class MyPortfolio extends Component {
  render() {
    const { theme, isDark, onToggle } = this.props;

    return (
      <div>
        <Fade bottom duration={1200}>
          <Experience
            theme={theme}
            isDark={isDark}
            onToggle={onToggle}
            showPageChrome={false}
          />
        </Fade>

        <Fade bottom duration={1200}>
          <Education
            theme={theme}
            isDark={isDark}
            onToggle={onToggle}
            showPageChrome={false}
          />
        </Fade>

        <Fade bottom duration={1200}>
          <Projects
            theme={theme}
            isDark={isDark}
            onToggle={onToggle}
            showPageChrome={false}
          />
        </Fade>

        <Fade bottom duration={1200}>
          <Opensource
            theme={theme}
            isDark={isDark}
            onToggle={onToggle}
            showPageChrome={false}
          />
        </Fade>
      </div>
    );
  }
}

export default MyPortfolio;
